module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "onboarding-tours": "static-1.15944"
    },
    "depPathPrefixes": {
      "onboarding-tours": "/onboarding-tours/static-1.15944"
    },
    "project": "onboarding-tours",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};